// @ts-nocheck
/* oxlint-disable no-undef */

/**
 * @typedef {Object} IBaseGlobals
 * @property {boolean} isDev  - Fejlesztői módban vagyunk?
 * @property {boolean} isProd - Production módban vagyunk?
 * @property {boolean} isTest - Tesztkörnyezetben vagyunk?
 */

/**
 * A webpack-től kapott globális konstans értékeink.
 * Az itt jelen levő értékeket projecttől függetlenül, minden környezetben megkapjuk.
 * Ezt lehet felülcsapni project-specifikusan.
 * @example
 * import baseGlobals from '@root/typescript/globals'
 *
 * const globals = {
 *   ...baseGlobals,
 *   myMagicConstant: __MY-MAGIC-CONSTANT__
 * }
 *
 * export default globals
 * @type {IBaseGlobals}
 */
const baseGlobals = {
  /* oxlint-disable no-restricted-globals */
  /* oxlint-disable no-restricted-globals */
  /* oxlint-disable no-underscore-dangle */
  isDev: globalThis.__DEV__,
  isProd: globalThis.__PROD__,
  isTest: globalThis.__TEST__
  /* oxlint-enable no-restricted-globals */
  /* oxlint-enable no-restricted-globals */
  /* oxlint-enable no-underscore-dangle */
}

module.exports.baseGlobals = baseGlobals
